 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"main": 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "vendors." + {"0":"83a0653e497753bf3614","1":"9aee01fb29964e73b598","2":"f5373d69668bb87bdd4c","3":"99969aa6f94fbf2a1561","4":"a1ea1cefcf89edebf602","5":"1c9642c62ccb475d3116","6":"54a5cf19dd41ad65ef6f","7":"113a9f431f7e07d0bdd4","vendors~Comment~ShareComment":"588b04d223348516d0a2","vendors~Comment~Survey":"3b7a10504aa365ed9efa","vendors~Comment":"1d8263d29360ea821902","Comment":"f3963901e69e66ca5457","vendors~Player":"5fe513d488643fffb26c","AccountOpening":"1c03c68ba881e0921bd0","BackTopBottom":"3ef17bb9f34c6c7f04a2","CallupVideoAppHead":"71401d5d94bccfe6941e","Caption":"25f1d9dc9017491e5a9b","Copyright":"bddca0aae0702785f40b","DataBox":"27589af951715066c99d","HomeFooter":"305e550278ee5e577c23","Hongbao":"9e820eab43adfa156a87","Img":"762e6d79ae40bcfac601","LivePlayer":"ceb27dd08aef4c8a273e","LoginDialog":"e7ae7031b26765c323d2","MoreTabs":"bd04546e4b18c5207a33","Nav":"59dd0eb268994dc1b89a","NormalCaption":"e6db8e423d94d3f9f6a1","Offline":"fe35f5d4fe63a82d2a67","QQShare":"f6141b5b8dff28c2bef2","SimpleGuideLayer":"0e3a369a504df4d5120b","Tip":"644d4e3fba4243f60406","ViewMoreLink":"7ae8a09d0e3ddb46ed97","vendors~Atlas~FiveNavPic~FourNavPic~InformationFlow~MdBanner~ThreeNavPic":"ddb2d04d5fc970537c83","Atlas":"4501b46fffc8a50a9c39","FiveNavPic":"54f5a194e95055906425","FourNavPic":"ca1afb5576caf79cdd56","ThreeNavPic":"0006101e427e047c9550","vendors~MdBanner":"4a4a3f22ecc102f4fb08","vendors~BigImage~NewsStream~NoImage~OneImage~Stick~ThreeImage~TwoImage":"a47fb2df0a524048aa00","BigImage":"f96d03c87d729f4b8bda","NoImage":"9f0ada7b5be35e6a0cff","OneImage":"f24b66ef1ab0c464f5ac","Stick":"4b5174169a5612d37ba6","ThreeImage":"47f2e1289c7446974c14","TwoImage":"a381e59e05d5d134352f","vendors~NewsStream":"13044a9f4ecf2019ba32","vendors~BigImg~BigTopic~InformationFlow~SingleTitle~SlideImg~TitleImg~TwoImg":"6213f8ecffe8f1c3a6af","BigImg":"e9e559dad25b886e4067","SingleTitle":"36015007b9de949fe707","SlideImg":"4fa4263d9ba0e37a4517","TwoImg":"4fa628064ea3fe4e84f8","vendors~BigTopic~InformationFlow~TitleImg":"8b7505ce9c4a5ccbcc7f","vendors~InformationFlow":"e2f94dac423002991c90","BigTopic":"604dbbb3fff02ef9a889","TitleImg":"b5247b6989914a80e4ef","vendors~BottomSlides~IndexSlides~NormalSlides~ShareSlides~Slides~UpgradeBottomSlides":"5091aaab4b661e66d6f7","BottomSlides":"7876bee1d56b8753042a","IndexSlides":"c70fbdd7d5a5c0e64f79","NormalSlides":"783110f7509994e407a2","ShareSlides":"1f24c1a28b21e2589f14","vendors~UpgradeBottomSlides":"03581fb477b08cc9ee7d","vendors~CallupHead":"bd05c1dda0e4feee0874","vendors~ShareComment":"4945354a01d25dc502ef","vendors~Survey":"49fd2bad81b410476376","vendors~MarkTabs":"86c4c05e5ebbc06fb7fa","vendors~NormalTabs":"b3362fca7558ab2e7908","vendors~SlidesTabs":"ecbafc5006e8f72e21eb","vendors~WXGuideLayer":"5b15910131b87463a54e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://x2.ifengimg.com/fe/shank/channel/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 0);
